import ExtendableError from '../lib/ExtendableError';

export class ScriptLoadError extends ExtendableError {
    constructor (src, loadError) {
        super(`Error loading script: ${src}`, { loadError });
        this.loadError = loadError;
    }
    name = 'ScriptLoadError'
}

export function loadScript (src, id = null) {
    return new Promise(function (resolve, reject) {
        const script = document.createElement('script');
        if (id) {
            script.setAttribute('id', id);
        }

        script.setAttribute('src', src);
        document.head.appendChild(script);

        // All normal amazing browsers
        if (script.onload) {
            script.onload = () => resolve(script);
            script.onerror = (error) => reject(new ScriptLoadError(src, error));
        }

        // Microsofts stupid annoying browsers
        if (script.addEventListener) {
            script.addEventListener('load', () => resolve(script), false);
            script.addEventListener('error', (error) => reject(new ScriptLoadError(src, error)), false);
        } else if (script.readyState) {
            script.onreadystatechange = () => resolve(script);
            script.onerror = (error) => reject(new ScriptLoadError(src, error));
        }
    });
}

export async function unloadScript (scriptPromise) {
    if (scriptPromise instanceof Promise) {
        const script = await scriptPromise;
        script.parentNode.removeChild(script);
        return true;
    } else if (scriptPromise.parentNode) {
        scriptPromise.parentNode.removeChild(scriptPromise);
    }

    return true;
}



// WEBPACK FOOTER //
// ./src/helpers/ExternalScript.js